import { render } from "./ContactlistComponent.vue?vue&type=template&id=517d88be"
import script from "./ContactlistComponent.vue?vue&type=script&lang=js"
export * from "./ContactlistComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__